import type { ElementType, ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils/cn";

const eyebrowStyles = "text-[11px] font-semibold uppercase tracking-[0.24em]";

const eyebrowToneStyles = {
  default: "text-ghost-gold",
  muted: "text-zinc-300",
  soft: "text-zinc-400",
  inherit: "text-inherit",
} as const;

type EyebrowProps<T extends ElementType = "span"> = {
  text: string;
  as?: T;
  tone?: "default" | "muted" | "soft" | "inherit";
  className?: string;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className" | "children">;

export default function Eyebrow<T extends ElementType = "span">({
  text,
  as,
  tone = "default",
  className,
  ...props
}: EyebrowProps<T>) {
  const Component = as || "span";

  return (
    <Component
      className={cn(eyebrowStyles, eyebrowToneStyles[tone], className)}
      {...props}
    >
      {text}
    </Component>
  );
}
